import { API_ENDPOINTS } from "@/config/api";
import { fetchApi } from "./api";

export type EmailProviderType = "mailtrap" | "gmail" | "sendgrid" | "brevo";

export type EmailTestTemplate =
  | "password_reset"
  | "business_invite"
  | "alert_notification";

export interface EmailConfig {
  active_email_provider: string;
  app_env: string;
  from_email: string;
  from_name: string;
  /** Map of provider name -> whether credentials are configured for it. No secrets. */
  configured: Record<string, boolean>;
}

export interface ProviderOverride {
  provider_type: EmailProviderType;
  /** brevo, sendgrid */
  api_key?: string;
  /** smtp providers (mailtrap, gmail) */
  host?: string;
  port?: number;
  username?: string;
  password?: string;
  from_email?: string;
  from_name?: string;
}

export interface TestEmailRequest {
  recipient_email: string;
  template: EmailTestTemplate;
  /** Omit to use the environment's configured providers. */
  override?: ProviderOverride;
}

export interface TestSendResult {
  success: boolean;
  provider: string;
  error: string | null;
}

export interface EmailTestLogEntry {
  recipient: string;
  subject: string;
  provider_name: string | null;
  status: string;
  error_message: string | null;
  created_at: string;
  sent_at: string | null;
}

export async function getEmailConfig(): Promise<EmailConfig> {
  return fetchApi<EmailConfig>(API_ENDPOINTS.emailTestConfig);
}

export async function sendTestEmail(
  payload: TestEmailRequest,
): Promise<TestSendResult> {
  return fetchApi<TestSendResult>(API_ENDPOINTS.emailTestSend, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function getTestHistory(): Promise<EmailTestLogEntry[]> {
  return fetchApi<EmailTestLogEntry[]>(API_ENDPOINTS.emailTestHistory);
}
